module.exports = __webpack_public_path__ + "static/media/certificadoiso.4797908f.jpg";